import { getStore } from "app/store/store"
import { IForm, IFormDataLoader } from "form/model"
import { ISsp } from "../model"
import { sspRPO } from "../repository"

export const sspFormDataLoader: IFormDataLoader = async (form: IForm, onFinish: (error?: string) => any) => {
  try {
    const allSspIds = getAllSspsInStore().map(s => s.id)
    const ssps = (await sspRPO.getCampaignSsps(form.tempCampaignId)).filter(
      ssp => allSspIds.includes(ssp.ssp_id) || ssp.ssp_id === UMBRACITY_SSP_ID
    )
    form.context.relations.ssps = ssps.length === 0 ? null : ssps
    form.screens.sspIds = ssps.map(e => e.ssp_id)
    form.screens.isLoadingSsp = false
    onFinish()
  } catch (error) {
    console.error(error)
    onFinish(`Ssp form data-loader error ${String(error)}`)
  }
}

export function getSspNameFromId(sspId: number): string {
  const ssp = getStore()
    .getState()
    .ssp.ssps.find(s => s.id === sspId)
  return ssp ? ssp.name : ""
}

export const getSspByIds = (sspIds: number[]): Promise<ISsp[]> => sspRPO.getSspsById(sspIds)

export function getAllSspsInStore(): ISsp[] {
  return getStore().getState().ssp.ssps
}
